import styled from 'styled-components';
import { cssUnitCalc } from 'utils';
import theme from 'styles/theme';
export const Wrapper = styled.div<any>`
    width: ${p => cssUnitCalc(p.width)};
    font-size: 14px;
    overflow: hidden;
    color: #101934;
    line-height: 20px;
    letter-spacing: 0.2px;
    display: inline-block;
    word-break: break-all;
    .foldable-span {
        color: ${p => p.theme.brand};
        cursor: pointer;
    }
`;

Wrapper.defaultProps = {
    theme,
};
